<template>
  <v-dialog :value="dialogProp.show" persistent max-width="950">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t(dialogProp.readonly
            ? 'Просмотр сессии'
            : 'Редактирование сессии') }}
          ({{ dialogProp.sessionType
            ? $t(SESSION_TYPE_ENUM[dialogProp.sessionType])
            : null }})
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col v-if="isLoading" cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col v-if="!!generalError" class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="px-3">
        <session-public-offers-info
            v-if="dialogProp.sessionType === SESSION_TYPES.PUBLIC_OFFERS"
            ref="session"
            :session-info="session"
            :lot="dialogProp.lot"
            :validated="updateSession"
            :readonly="dialogProp.readonly || isLoading" />
        <session-public-offers-divisible-volume-info
            v-if="dialogProp.sessionType === SESSION_TYPES.PUBLIC_OFFERS_DIVISIBLE_VOLUME"
            ref="session"
            :session-info="session"
            :lot="dialogProp.lot"
            :validated="updateSession"
            :readonly="dialogProp.readonly || isLoading" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t(dialogProp.readonly
            ? 'Закрыть'
            : 'Отмена') }}
        </v-btn>
        <v-btn
            v-if="!dialogProp.readonly"
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import SessionPublicOffersInfo from './SessionPublicOffersInfo.vue'
  import SessionPublicOffersDivisibleVolumeInfo from './SessionPublicOffersDivisibleVolumeInfo.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { SESSION_TYPE_ENUM } from '@/constants/enums'
  import { SESSION_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { LOT_SESSIONS_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      SessionPublicOffersInfo,
      SessionPublicOffersDivisibleVolumeInfo
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            sessionId: null,
            sessionType: null,
            lot: {
              lotId: null
            },
            readonly: false,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        SESSION_TYPES,
        SESSION_TYPE_ENUM,
        isLoading: false
      }
    },
    computed: {
      ...mapState(LOT_SESSIONS_MANAGEMENT.NAMESPACE, {
        session: state => (state[LOT_SESSIONS_MANAGEMENT.STATE.CURRENT_SESSION] || {
          invitedOrganizations: []
        })
      })
    },
    created () {
      this.clearStore().then(() => {
        if (!this.dialogProp.lot.lotId) {
          this.showErrorAction({
            message: this.$t('Данные для изменения сессии указаны некорректно.')
          })
          return
        }
        this.getSessionInfo()
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOT_SESSIONS_MANAGEMENT.NAMESPACE, {
        getSessionInfoAction: LOT_SESSIONS_MANAGEMENT.ACTIONS.GET_SESSION_INFO,
        updateSessionAction: LOT_SESSIONS_MANAGEMENT.ACTIONS.UPDATE_SESSION,
        clearSessionInfoAction: LOT_SESSIONS_MANAGEMENT.ACTIONS.CLEAR_SESSION_INFO
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.hideErrorAction(),
            this.clearSessionInfoAction()
          ])
      },
      continueOperation: async function () {
        try {
          this.isLoading = true
          await this.$refs.session.validate()
          if (this.dialogProp.callback) {
            await this.dialogProp.callback()
            this.isLoading = false
            this.cancel()
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      getSessionInfo: async function () {
        try {
          this.isLoading = true
          await this.getSessionInfoAction({
            lotId: this.dialogProp.lot.lotId,
            lotType: this.dialogProp.lot.lotType,
            sessionId: this.dialogProp.sessionId,
            sessionType: this.dialogProp.sessionType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      updateSession: async function (session) {
        await this.updateSessionAction({
          lotId: this.dialogProp.lot.lotId,
          lotType: this.dialogProp.lot.lotType,
          sessionId: this.dialogProp.sessionId,
          sessionType: this.dialogProp.sessionType,
          session
        })
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
